import { render, staticRenderFns } from "./footerDown.vue?vue&type=template&id=d4272aaa&scoped=true&"
import script from "./footerDown.vue?vue&type=script&lang=js&"
export * from "./footerDown.vue?vue&type=script&lang=js&"
import style0 from "./footerDown.vue?vue&type=style&index=0&id=d4272aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4272aaa",
  null
  
)

export default component.exports